<template>

    <div>
        <h4>Ödeme Bilgisi</h4>
        <p v-if="value.Count < 3"><span class="font-weight-bold text-danger">Bilgilendirme:</span> Aynı bankadan aynı grup koduna ait ödemelerde en az 3 hatalı ödeme denemesi olduktan sonra banka gönderim özelliği açılır.</p>
        <div class="row col-md-12">
        
        <br/>
        <table align="center" class="text-center" border="1">
            <thead>
                <tr>
                    <td class="font-weight-bold">Cari Kodu</td>
                    <td class="font-weight-bold">Cari Adı</td>
                    <td class="font-weight-bold">Banka</td>
                    <td class="font-weight-bold">Deneme Sayısı</td>
                    <td class="font-weight-bold">Plasiyer Kodu</td>
                    <td class="font-weight-bold">Bankaya Gönderildi Mi?</td>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{ value.CustomerCode }}</td>
                    <td>{{ value.CustomerName }}</td>
                    <td>{{ value.BankStr }}</td>
                    <td>{{value.Count}}</td>
                    <td>{{ value.PlasiyerCode }}</td>
                    <td>{{ value.IsSentToBank ? 'Evet' :'Hayır' }}</td>
                </tr>
            </tbody>
        </table>
       
    </div>
    <hr/>
    <h4>Ödeme Hataları</h4>
    <div class="row col-md-12">
        
        <table align="center" style="width: 100%;" class="text-center" border="1">
            <thead>
                <tr>
                    <td class="font-weight-bold">Order Id</td>
                    <td class="font-weight-bold">Hata Kodu - 1</td>
                    <td class="font-weight-bold">Hata Kodu - 2</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="errorDetail in value.ErrorDetails">
                    <td>{{ errorDetail.OrderId }}</td>
                    <td>{{ errorDetail.Error1 }}</td>
                    <td>{{ errorDetail.Error2 }}</td>
                </tr>
            </tbody>
        </table>
    </div>
    </div>
    
    
</template>

<script>
export default {
    props:{
        value:Object
    },
    
}
</script>

<style>

</style>